import { useState } from 'react';
import { useToast } from '../../context/ToastProvider.js';
import './../../styles/Modal.css';

function LayerCopyModal({
    currentConfig,
    currentSide,       
    currentOption,      
    templates,              
    onClose,          
    onCopiedCurrentLayer,
    onCopiedTemplateLayer,
    productHandle
}) {
    const [ selectedRadioOption , setSelectedRadioOption ] = useState( 'current' );
    const [ sortedTemplates , setSortedTemplates ] = useState( sortTemplatesByCategory( templates ) );
    const [ selectedCategory, setSelectedCategory ] = useState( "" );
    const [ selectedTemplateId, setSelectedTemplateId ] = useState( -1 );
    const [ selectedTemplateSide , setSelectedTemplateSide ] = useState( "" );
    const [ selectedTemplateOption , setSelectedTemplateOption ] = useState( "" );

    function sortTemplatesByCategory( templates ) {
        const sortedTemplates = {};

        for ( let i = 0; i < templates.length; i++ ) {
            const category = templates[i].category;

            if ( typeof( sortedTemplates[category] ) === 'undefined' ) {
                sortedTemplates[ category ] = [];
            }

            sortedTemplates[ category ].push( templates[i] );
        }

        return sortedTemplates;
    }

    function getTemplateById( id ) {
        const templateValues = Object.values( sortedTemplates );
        
        let foundTemplate = {};
        for ( const templates of templateValues ) {
            const found = templates.find( ( t ) => t.id === id );
            if ( found ) { 
                foundTemplate = found;
                break;
            }
        }

        return foundTemplate;
    }

    function copyToClipboard() {
        const selectedCopyType = selectedRadioOption;
        if ( selectedCopyType === "current" ) {
            if ( typeof ( onCopiedCurrentLayer ) === 'function' ) {
                onCopiedCurrentLayer();
            }
        } 
        else if ( selectedCopyType === "template" ) {
            if ( typeof ( onCopiedCurrentLayer ) === 'function' ) {
                const layersToCopy = structuredClone( getTemplateById( selectedTemplateId ).saved_config[selectedTemplateSide][selectedTemplateOption] );
                for ( let i = 0; i < layersToCopy.length; i++ ) {
                    layersToCopy[i].related_product_handle = productHandle;
                }

                onCopiedTemplateLayer( layersToCopy );
            }
        }
    }

    return(
        <div className="modal-overlay">
            <div className="modal-content">
                <h1>Copy Layers</h1>

                <div className="tabs">
                    <input
                        type="radio"
                        id="copy-type--current"
                        name="copy_type"
                        value="current"
                        onChange={ () => {
                            setSelectedRadioOption( "current" );
                        }}
                        checked={ selectedRadioOption === "current" }
                    />
                    <label htmlFor="copy-type--current">From Current Config</label>
                    <input
                        type="radio"
                        id="copy-type--template"
                        name="copy_type"
                        value="template"
                        onChange={ () => {
                            setSelectedRadioOption( "template" );
                        }}
                        checked={ selectedRadioOption === "template" }
                    />
                    <label htmlFor="copy-type--template">From Templates</label>
                </div>
                
                { selectedRadioOption === "current" &&
                    <div className="tab-body">
                        <div className="info-header">
                            <div><strong>Selected Side:</strong> {currentSide}</div>
                            <div><strong>Selected Option:</strong> {currentOption}</div>
                        </div>

                        <div className="layer-list">
                            <div className="tab-section-title">Layers to Copy</div>
                            {currentConfig[currentSide][currentOption].length > 0 ? (
                                currentConfig[currentSide][currentOption].map((layer) => (
                                    <div className="layer-item" key={layer.id}>
                                        {layer.title}
                                    </div>
                                ))
                            ) : (
                                <div className="no-layers">No layers available to copy.</div>
                            )}
                        </div>
                    </div>
                }

                { selectedRadioOption === "template" &&
                    <div className="tab-body">
                        {/* Category Selector */}
                        <div className="form-group">
                            <label>Select Template Category</label>
                            <select
                                value={selectedCategory}
                                onChange={(e) => {
                                    setSelectedCategory(e.target.value);
                                    setSelectedTemplateId(-1);
                                    setSelectedTemplateSide("");
                                    setSelectedTemplateOption("");
                                }}
                            >
                                <option disabled value="">-- Choose Category --</option>
                                {Object.keys(sortedTemplates).map((category) => (
                                    <option key={category} value={category}>{category}</option>
                                ))}
                            </select>
                        </div>

                        {/* Template Selector */}
                        {selectedCategory && (
                            <div className="form-group">
                                <label>Select Template</label>
                                <select
                                    value={selectedTemplateId}
                                    onChange={(e) => {
                                        setSelectedTemplateId(Number(e.target.value));
                                        setSelectedTemplateSide("");
                                        setSelectedTemplateOption("");
                                    }}
                                >
                                    <option disabled value={-1}>-- Choose Template --</option>
                                    {sortedTemplates[selectedCategory].map((template) => (
                                        <option key={template.id} value={template.id}>
                                            {template.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {/* Side Selector */}
                        {selectedTemplateId !== -1 && (
                            <div className="form-group">
                                <label>Select Side</label>
                                <select
                                    value={selectedTemplateSide}
                                    onChange={(e) => {
                                        setSelectedTemplateSide(e.target.value);
                                        setSelectedTemplateOption("");
                                    }}
                                >
                                    <option disabled value="">-- Choose Side --</option>
                                    <option value={"front"}>front</option>
                                    <option value={"back"}>back</option>
                                </select>
                            </div>
                        )}

                        {/* Option Selector */}
                        {selectedTemplateSide && (
                            <div className="form-group">
                                <label>Select Option</label>
                                <select
                                    value={selectedTemplateOption}
                                    onChange={(e) => setSelectedTemplateOption(e.target.value)}
                                >
                                    <option disabled value="">-- Choose Option --</option>
                                    {Object.keys( getTemplateById( selectedTemplateId ).saved_config[selectedTemplateSide] || {}).map((option) => (
                                        <option key={option} value={option}>{option}</option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {/* Layer Preview */}
                        {selectedTemplateOption && (
                            <div className="layer-list">
                                <div className="tab-section-title">Layers in Template</div>
                                {getTemplateById( selectedTemplateId ).saved_config[selectedTemplateSide][selectedTemplateOption].map( ( layer ) => (
                                    <div className="layer-item" key={layer.id}>
                                        {layer.title}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                }

                <div className="modal-controls">
                    <button type="button" className="cancel-btn" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="done-btn"
                        disabled={
                            ( selectedRadioOption === "template" && selectedTemplateOption === "" )
                        }
                        onClick={ copyToClipboard }
                    >
                        Copy
                    </button>
                </div>
            </div>
        </div>
    )
}

export default LayerCopyModal;